import { linearGradient } from "polished"

const colorConfigs = {
  "Gray/Flat Button Bg": "#CBD0D1",
  "Text/Dark": "#CC0000",
  "Text/Blue": "#0085CA",
  "Text/Primary Pink": "#E31C79",
  "Text/Gray": "#CBD0D1",
  "Text/Black2": "#000000",
  "Text/Gray Preview": "#606365",
  "Text/Gray Success": "#7C7C7C",
  "Gray/Card Border, Line": "#7C7C7C",
  "Text/Dark Grey": "#767676",
  "Other/Danger": "#F34336",
  "Other/Warning": "#FF9800",
  "Other Light/Danger": "#FCECE9",
  "Primary/Brown": "#805D57",
  "Dark Blue/Primary Text": "#003C71",
  //
  "Gray/Primary Text": "#000000",
  "Light Blue/Flat Button Background": "#E3F1F9",
  "Error/Error Text": "#FE7015",
  Success: "#74B62D",
  Warning: "#EEC11B",
  "Error/Line": "#F6A660",
  "Primary/Line": "#CC0000",
  "Primary/Hover": "#9A0000",
  "Light /Button Background": "#FFFFFF",
  "Primary/Light Hover": "#FFE4E5",
  "Primary/Primary Text": "#000000",
  "Gray/Bg": "#F5F6F6",
  "White / White": "#FFFFFF",
  "Primary/Background": "#CC0000",
  "Text/Primary Text": "#000000",
  "Text/Secondary Text": "#333333",
  "Text/Secondary": "#7C7C7C",
  "Text/Line": "#7C7C7C",
  "Text/Placeholder": "#585858",
  "Text/Background": "#EAEAEA",
  "Approve / Waiting ": "#FFFFFF",
  "System/Warning Light": "#FFE4E5",
  "System/Error Light Hover": "#FFEBEB",
  "System/Info": "#005AE0",
  "System/Info Light": "#E0EDFF",
}

const backGroundColorGradient = linearGradient({
  colorStops: [`${colorConfigs["Primary/Background"]} 81.24%`, `${colorConfigs["Primary/Background"]} 96.64%`],
  toDirection: "213deg",
  fallback: colorConfigs["Primary/Background"],
})

const colors = { colors: colorConfigs, gradient: backGroundColorGradient }

export default colors
